export default __webpack_public_path__ + "static/media/required.133ea6a0.png";